import {FormDynamic} from "./FormDynamic";

export default FormDynamic;